"use client";
import React from "react";
import { useNavigate } from "react-router-dom"; // import the hook

function InviteSection({
  imageSrc = "https://cdn.builder.io/api/v1/image/assets/TEMP/84e6ab189c2112cda08106264714eed56abc53af?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689",
  title = "Invite & Earn 2% Every Time They Stake",
  subtitle = "Share your link. Get paid. No limits.",
  buttonText = "Get Your Link",
  buttonIcon = "https://cdn.builder.io/api/v1/image/assets/TEMP/d0e4879ce558b9b1f01d36dc5c7cdbb500bc77dd?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689",
  onButtonClick
}) {

  const navigate = useNavigate();

  const handleClick = async () => {
    // ✅ Example action: log, API call, wallet check, etc.
    console.log("Button clicked");

    // 🟣 You can also await something here if needed:
    // await someAsyncFunction();

    // ✅ Then navigate
    navigate("/profile");
  };
  
  return (
    <section className="flex flex-col justify-center items-center px-16 py-20 text-white max-md:px-5">
      {/* Responsive flex: column on mobile/tablet, row on desktop */}
      <div className="flex flex-col md:flex-col lg:flex-row gap-10 items-center justify-center w-full max-w-[1200px] mx-auto">
        {/* IMAGE */}
        <img
          src={imageSrc}
          alt="Referral program illustration"
          className="object-contain rounded-none aspect-[0.87] min-w-60 w-[385px] mx-auto"
        />

        {/* CONTENT */}
        <div className="flex flex-col justify-center items-center text-center my-auto min-w-60 w-full max-w-[739px]">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight md:leading-[60px] lg:leading-[80px] text-white font-fredoka">
            <span style={{fontFamily: 'Baloo 2, -apple-system, Roboto, Helvetica, sans-serif'}}>
              Invite &{" "}
            </span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
              Earn 2%
            </span>
            <span style={{fontFamily: 'Baloo 2, -apple-system, Roboto, Helvetica, sans-serif'}}>
              {" "}Every Time They Stake
            </span>
          </h1>

          <p className="mt-8 text-lg md:text-2xl leading-7 md:leading-9 text-zinc-100">
            {subtitle}
          </p>

          <div className="flex gap-6 items-center justify-center mt-8 w-full">
        <button
      onClick={handleClick}
      className="flex items-center justify-center gap-2.5 px-8 py-4 w-full md:w-auto rounded-full border-2 border-white shadow-[0px_4px_16px_#ff49b8] bg-gradient-to-r from-[#ff6eb3] via-[#aa81ff] to-[#6bc9ff] text-white text-lg md:text-[22px] font-semibold"
    >
      {buttonText}
      <img
        className="w-[25px] h-[25px]"
        alt="Arrow right"
        src={buttonIcon}
      />
    </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InviteSection;
